"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = void 0;
exports.ROUTE = "interaction-foreground";
//# sourceMappingURL=constants.js.map